import selectorsConfig from "../config/problemCreatorSelectors.js";

import filterAbstract from "./filterAbstract.js";

export default filterAbstract(selectorsConfig);
